<div class="row mt-2">
  <div class="col p-3 wccard">
    <div class="d-flex mt-1 justify-content-between">

      <div class="d-flex align-items-center">
        <p class="pointer f-14 font-weight-500" [ngStyle]="{'color': showYourTeamTab ? '#2E93A1': '#484B59'}"
          >Your Team ({{teamListCount}})</p>
      </div>



    </div>
  </div>
</div>


<!-- For Your Team Tabs -->
<div class="row mt-1" *ngIf="showYourTeamTab">

  <!-- If Your Team Not Available -->
  <div *ngIf="tabList.length == 0 && !adminDetails" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No Team Members Yet, Start Inviting!</p>
      </div>
    </div>
  </div>

  <!-- If Your Team Available -->
  <div class="col" *ngIf="tabList.length > 0 || adminDetails">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">
      <div class="col-md-5">
        <div class="d-flex">

          <div>
            <span class="f-14 font-weight-400" style="color: #969696;">
              Name
            </span>
          </div>
        </div>
      </div>

      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Role
        </span>
      </div>

       <div class="col" *ngIf="planDetails?.isteamadmin">
        <span class="f-14 font-weight-400" style="color: #969696;">
         Access
        </span>
      </div>
    </div>

    <div class="row align-items-center p-2 wccard" style="margin-top: 1px;" *ngIf="adminDetails">
      <div class="col-md-5">
        <div class="d-flex align-items-center">
         <div>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-14" style="color: #484B59;"> {{adminDetails?.firstname}} {{adminDetails?.lastname}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-12" style="color: #969696;"> {{adminDetails?.loginemail}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{adminDetails?.role? adminDetails?.role : 'Admin'}}
        </span>
      </div>

      <div class="col" *ngIf="planDetails?.isteamadmin">

          </div>
    </div>

    <div class="row align-items-center p-2 wccard" style="margin-top: 1px;" *ngFor="let team of tabList; let i=index;">
      <div class="col-md-5">
        <div class="d-flex align-items-center">

          <div>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-14" style="color: #484B59;"> {{team?.firstname}} {{team?.lastname}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-12" style="color: #969696;"> {{team?.inviteeemailid}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{ team?.role === 'teammember' ? 'Team Member' : (team?.role ? team.role : 'Team Member') }}
        </span>
      </div>
      <div class="col" *ngIf="planDetails?.isteamadmin">
        <div class="custom-control custom-switch">
              <input data-testid="auto-app-autopilot-permission-input-1" type="checkbox" class="custom-control-input" [id]="'customSwitch' + i" [formControl]="autopilotAccessControl" (change)="toggleAutopilotAcces(team)" [checked]="team?.hasaisourcingaccess">
              <label class="custom-control-label" [for]="'customSwitch' + i"></label>
            </div>
          </div>
    </div>
  </div>

</div>


<!-- For Pending Tabs -->
<div class="row mt-1" *ngIf="showPendingTab">

  <!-- If Pending Not Available -->
    <div *ngIf="tabList.length == 0" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No Team Members Yet, Start Inviting!</p>
      </div>
    </div>
  </div>

  <!-- If pending Available -->
  <div class="col" *ngIf="tabList.length > 0">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">
      <div class="col-md-5">
        <div class="d-flex">
          <!-- <label class="wc-checkbox mr-3 p-0">
            <input data-testid="auto-app-autopilot-permission-input-2" [(ngModel)]="selected" (change)="selectAll(selected)" [ngModelOptions]="{standalone: true}"
              type="checkbox" id="mycheck" name="mycheck">
            <i class="fas fa-check"></i>
          </label> -->
          <div>
            <span class="f-14 font-weight-400" style="color: #969696;">
              Name
            </span>
          </div>
        </div>


      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Role
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Sent On
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Actions
        </span>
      </div>
    </div>

    <div class="row align-items-center mt-1 p-2 wccard" *ngFor="let team of tabList" [ngStyle]="{ 'background-color': team?.expired ? '#FAFAFA' : '#FFFFFF' }">
      <div class="col-md-5">
        <div class="d-flex align-items-center">
          <!-- <label class="wc-checkbox mr-2 mb-0 d-flex">
            <input data-testid="auto-app-autopilot-permission-input-3" type="checkbox" id="mycheck" name="mycheck" [checked]="team?.selected" [(ngModel)]="team.selected"
              (change)="checkIfAllSelected(team, team?.selected)">
            <i class="fas fa-check"></i>
          </label> -->

          <div>
            <p class="mb-1 pointer no-outline">
              <span class="f-14 font-weight-400" style="color: #484B59;"> {{team?.firstname | titlecase}} {{team?.lastname | titlecase}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="f-12 font-weight-400" style="color: #969696;"> {{team?.inviteeemailid}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{ team?.role === 'teammember' ? 'Team Member' : (team?.role ? team.role : 'Team Member') }}
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{team?.createdon | date: 'MMM dd, yyyy' }}
        </span>
      </div>
      <div class="col">
        <div class="d-flex" *ngIf="!team?.expired">
          <div (click)="revokeInvitation(team)" class="d-flex justify-content-center align-items-center cross-icon"  matTooltip="Revoke" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <span class="f-14 font-weight-400" style="color: #484B59;" *ngIf="team?.expired">Invitation Expired</span>
      </div>
    </div>
  </div>

</div>


<!-- For Invitation Tabs -->
<div class="row mt-1" *ngIf="showInvitationTab">

  <!-- If Invitation Not Available -->
    <div *ngIf="userRemindLaterInvites.length == 0" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No Team Members Yet, Start Inviting!</p>
      </div>
    </div>
  </div>

  <!-- If Invitation Available -->
  <div class="col" *ngIf="userRemindLaterInvites.length > 0">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">

      <div class="col-md-5">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Invited By
        </span>
      </div>
      <div class="col-md-5">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Invited On
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Actions
        </span>
      </div>
    </div>

    <div class="row align-items-center mt-1 wccard" *ngFor="let team of userRemindLaterInvites" [ngStyle]="{ 'background-color': team?.expired ? '#FAFAFA' : '#FFFFFF' }">
      <div style="width: 4px; height: 59px;" [ngStyle]="{ 'background-color': team?.expired ? '#969696' : '#2E93A1' }"></div>
      <div class="col-md-5">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-1 pointer no-outline">
              <span class="f-14 font-weight-400" style="color: #484B59;">{{team?.adminfirstname | titlecase}} {{team?.adminlastname | titlecase}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="f-12 font-weight-400" style="color: #969696;">{{team?.adminemail}}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">{{team?.updatedon | date: 'dd MMM yyy'}}</span>

      </div>

      <div class="col">
          <div class="row" *ngIf="!team?.expired">
            <div class="col text-right">
              <button data-testid="auto-app-autopilot-permission-button-1" class="btn-trms-white mr-3" (click)="openRejectInvitationModel(team)">Reject</button>
              <button data-testid="auto-app-autopilot-permission-button-2" class="btn-trms-small" (click)="openConfirmInvitationModel(team)">Accept</button>
            </div>
          </div>
          <span class="f-14 font-weight-400" style="color: #484B59; margin-left: 100px;" *ngIf="team?.expired">Invitation Expired</span>
      </div>
    </div>
  </div>

</div>




<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

